import { SerializedStyles } from "@emotion/react";
import * as React from "react";

import { Button, Icon, IconSource, Popover } from "@livechat/design-system-react-components";

import { Body, BoxContainer, Footer, Header, Title } from "components/filter/shared";

interface IProps {
  title: string;
  icon: IconSource;
  isOpen: boolean;
  isValid?: boolean;
  boxCss?: SerializedStyles;
  buttonCss?: SerializedStyles;
  actionButtonText?: string;
  onActionButtonClick?(): void;
  onFilterRemoveClick?(): void;
  onClose(): void;
  onOpen?(): void;
  renderContent(): React.ReactNode;
  children?: React.ReactNode;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const ControlledFilter = (props: IProps) => {
  const {
    isOpen,
    onClose,
    onOpen,
    onActionButtonClick,
    actionButtonText,
    renderContent,
    title,
    icon,
    isValid,
    boxCss,
    buttonCss,
    children,
  } = props;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }
  };

  return (
    <Popover
      isVisible={isOpen}
      onClose={onClose}
      onOpen={handleOpen}
      placement="bottom-start"
      triggerRenderer={() => children}
    >
      <BoxContainer css={boxCss}>
        <Header>
          <Icon source={icon} />
          <Title>{title}</Title>
        </Header>
        <Body>{renderContent()}</Body>
        <Footer>
          <Button
            disabled={!isValid}
            css={buttonCss}
            kind="primary"
            onClick={onActionButtonClick}
            type="button"
            fullWidth
          >
            {actionButtonText}
          </Button>
        </Footer>
      </BoxContainer>
    </Popover>
  );
};
